var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSfticon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2074_26825)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2074_26825",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 10,
    height: 10
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.570312 0.5H9.57031V9.5H0.570312V0.5Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2074_26825)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.91406 2.46875C5.75874 2.46875 5.63281 2.34283 5.63281 2.1875C5.63281 2.03217 5.75874 1.90625 5.91406 1.90625H7.88281C7.90129 1.90625 7.91958 1.90805 7.93767 1.91165C7.95579 1.91526 7.97338 1.92059 7.99045 1.92766C8.00749 1.93473 8.02369 1.94339 8.03905 1.95365C8.05441 1.96391 8.06862 1.97557 8.08167 1.98863C8.09475 2.00168 8.10642 2.01589 8.11668 2.03125C8.12694 2.0466 8.13559 2.06281 8.14264 2.07987C8.14972 2.09693 8.15506 2.11452 8.15866 2.13263C8.16226 2.15074 8.16406 2.16903 8.16406 2.1875V4.15625C8.16406 4.31158 8.03815 4.4375 7.88281 4.4375C7.72747 4.4375 7.60156 4.31158 7.60156 4.15625V2.866L2.93679 7.53125H4.22656C4.38189 7.53125 4.50781 7.65716 4.50781 7.8125C4.50781 7.96784 4.38189 8.09375 4.22656 8.09375H2.25781C2.23935 8.09375 2.22106 8.09195 2.20294 8.08835C2.18483 8.08475 2.16724 8.07941 2.15018 8.07233C2.13312 8.06528 2.11691 8.05662 2.10156 8.04636C2.0862 8.0361 2.072 8.02444 2.05894 8.01135C2.04588 7.9983 2.03422 7.9841 2.02396 7.96874C2.0137 7.95338 2.00504 7.93718 1.99797 7.92014C1.9909 7.90307 1.98557 7.88547 1.98197 7.86735C1.97836 7.84926 1.97656 7.83098 1.97656 7.8125V5.84375C1.97656 5.68842 2.10248 5.5625 2.25781 5.5625C2.41314 5.5625 2.53906 5.68842 2.53906 5.84375V7.13349L7.20331 2.46875H5.91406Z",
    fill: "#222222"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2074_26825"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9,
    height: 9,
    fill: "white",
    transform: "translate(0.570312 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSfticon);
export default __webpack_public_path__ + "static/media/sfticon.7810be3b37d5062ed7190d728f9ec8a0.svg";
export { ForwardRef as ReactComponent };